import HTMLReactParser from 'html-react-parser';
import React from 'react';
import { useMergeTagsContext } from '../../../../../../common/context/MergeTagsContext';

export interface IMergeTagProps {
  id?: string;
}

export const MergeTag = (props: IMergeTagProps) => {
  const { mergeTags } = useMergeTagsContext();
  const mergeTag = mergeTags && mergeTags[props?.id];

  return <>{mergeTag?.content ? HTMLReactParser(mergeTag.content) : null}</>;
};
